import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { parseDateFormat } from '../utils/util-functions';

@Pipe({
  name: 'storeBasedDate'
})
export class StoreBasedDatePipe implements PipeTransform {

  constructor(
    private datePipe: DatePipe
  ) {}

  transform(date: Date | string, ...args: any[]): any {
    /*
    args values
      1. timeZone : true | false
      2. date : 'dd'
      3. month : 'MM'
      4. year : 'yyyy'
      5. date delimiter : '-'
      6. optional : ' hh:mm:ss'
    */
    let newDate = date;
    if(args.length > 5) {
      newDate = parseDateFormat(this.datePipe, date, args[0], args[1], args[2], args[3], args[4], args[5]);
    }else {
      newDate = parseDateFormat(this.datePipe, date, args[0], args[1], args[2], args[3], args[4]);
    }
    return newDate;
  }

}
